<template>
  <div class="sim">
    <div class="flex">
      <button @click="ChangePasso(1)">Voltar</button>
    </div>
    <div class="flex mt-24 gap18" :style="ladrilho.horizontal && !ladrilho.floral ? 'flex-direction:column;': ''">
      <div class="col" ref="col" id="pdf" style="max-width: 100%">
        <div class="p-relative">
          <div class="normal" v-if="!ladrilho.modulado && !ladrilho.hexagonal">
            <div class="contentS flex-grid" :style="'grid-template-columns: repeat('+ colunas + ', 1fr);max-width:100%;'"
                 v-if="!ladrilho.floral" >
              <div v-for="item in (colunas * linhas)" v-html="contentSVG" :style="'border: 1px solid '+ cor.hex+';max-width: 100%;'">
              </div>
            </div>
            <div class="contentS flex-grid"
                 :style="'grid-template-columns: repeat('+ colunas + ', '+ Math.ceil(512 / colunas) + 'px)'"
                 v-if="ladrilho.floral">
              <template v-for="linha in linhas">
                <template v-for="coluna in colunas">
                  <div v-if="coluna == 1 && linha == 1" v-html="contentSVG2"
                       :style="'border: 1px solid '+ cor.hex"></div>
                  <div v-if="coluna != 1 && linha == 1 && coluna != colunas" v-html="contentSVG"
                       :style="'border: 1px solid '+ cor.hex"></div>
                  <div v-if="coluna == colunas && linha == 1" v-html="contentSVG2" class="svgRM90"
                       :style="'border: 1px solid '+ cor.hex"></div>

                  <div v-if="coluna == 1 && linha != 1 && linha != linhas" v-html="contentSVG" class="svgRL90"
                       :style="'border: 1px solid '+ cor.hex"></div>
                  <div v-if="coluna != 1 && linha != 1 && coluna != colunas && linha != linhas"
                       style="border: 1px solid "
                       :style="'border: 1px solid '+ cor.hex + ';background-color:' + cor.hex"></div>
                  <div v-if="coluna == colunas && linha != 1 && linha != linhas" v-html="contentSVG" class="svgRM90"
                       :style="'border: 1px solid '+ cor.hex"></div>

                  <div v-if="coluna == 1 && linha == linhas" v-html="contentSVG2" class="svgRL90"
                       :style="'border: 1px solid '+ cor.hex"></div>
                  <div v-if="coluna != colunas && linha == linhas && coluna != 1" class="svgRL180" v-html="contentSVG"
                       :style="'border: 1px solid '+ cor.hex"></div>
                  <div v-if="coluna == colunas && linha == linhas" v-html="contentSVG2" class="svgRL180"
                       :style="'border: 1px solid '+ cor.hex"></div>
                </template>
              </template>
            </div>
          </div>
          <div class="modulado" v-if="ladrilho.modulado && !ladrilho.hexagonal">
            <div class="contentS flex-grid"
                 :style="'grid-template-columns: repeat('+ colunas + ', '+ Math.ceil(512 / colunas) + 'px)'">
              <template v-for="linha in linhas">
                <template v-for="coluna in colunas">
                  <div v-if="linha % 2 !== 0 && (coluna % 2 !== 0)" v-html="contentSVG"
                       :style="'border: 1px solid '+ cor.hex"></div>
                  <div v-if="linha % 2 !== 0 && (coluna % 2 === 0)" v-html="contentSVG"
                       :style="'border: 1px solid '+ cor.hex" class="svgRM90"></div>

                  <div v-if="linha % 2 === 0 && (coluna % 2 !== 0)" v-html="contentSVG"
                       :style="'border: 1px solid '+ cor.hex" class="svgRL90"></div>
                  <div v-if="linha % 2 === 0 && (coluna % 2 === 0)" v-html="contentSVG"
                       :style="'border: 1px solid '+ cor.hex" class="svgR180"></div>
                </template>
              </template>
            </div>
          </div>
          <div class="hexagonal" v-if="ladrilho.hexagonal">
            <div class="contentS flex-grid" :style="'grid-template-columns: repeat(1, 1fr)'">
              <div v-html="contentSVG" :style="'background-color:' + cor.hex"></div>
            </div>
          </div>
          <div class="abs">
            <div class="absText" >
              <p>Brasil Imperial Ladrilhos</p>
            </div>
          </div>
        </div>
        <div class="imprimir flex flex-between align-center">
          <div class="model">
            <p class="bold">
              {{ atual.modelo }} - {{ atual.tamanho }} - {{ atual.ladrilho }}
            </p>
          </div>
          <button @click="printEv">Imprimir</button>
        </div>
        <div class="overflow cores mt-24">
          <p style="margin-bottom: 8px">Cores utilizadas</p>
          <ul class="flex flex-wrap gap8">
            <li v-for="(corAc, ind) in coresUtilizadas" :class="corAc.hex == cor.hex ? 'act' : ''"
                @click="changeColor(corAc)">
              <span
                  :style="'background-color:' + corAc.hex + ' !important;display:block;      -webkit-print-color-adjust: exact; '"></span>
              <label for="">{{ corAc.name }}</label>
            </li>
          </ul>
          <div class="cor-rejunte">
            <p>Cor do rejunte</p>
            <li>
              <span
                  :style="'background-color:' + cor.hex + ' !important;display:block;      -webkit-print-color-adjust: exact; '"></span>
              <label for="">{{ cor.name }}</label>
            </li>
          </div>
        </div>
      </div>
      <div class="col">
        <div class="visu">
          <label for="">
            Opções de visualização
          </label>
          <div class="flex gap18">
            <div class="col">
              <div class="flex align-center">
                <label for="">Colunas</label>
                <input type="number" placeholder="Colunas" max="10" v-model="colunas"></div>
            </div>
            <div class="col">
              <div class="flex align-center">
                <label for="">Linhas</label>
                <input type="number" placeholder="Linhas" max="10" v-model="linhas"></div>
            </div>
          </div>
        </div>
        <div class="mt-24">
          <label>Selecione a cor do rejunte</label>
          <div class="overflow cores">
            <ul class="flex flex-wrap gap8">
              <li v-for="(corAc, ind) in cores" @click="act = ind; cor = corAc" :class="ind == act ? 'act' : ''">
                <span :style="'background-color:' + corAc.hex"></span>
              </li>
            </ul>
          </div>
          <p class="mt-24">
            As cores são apenas demonstrativas e aproximadas, podendo sofrer variações no ladrilho real.
          </p>
        </div>
      </div>
    </div>
    <div class="solicitarOrcamento">
      <div class="flex flex-between align-center">
        <div class="text">
          <h4> Ladrilho personalizado, agora só falta a produção. </h4>
          <h2> Solicite seu orçamento! </h2>
          <p> Ao nos enviar a solicitação, receberemos também o ladrilho que você personalizou. </p>
        </div>
        <div>
          <button @click="popup = true">Solicitar orçamento</button>
        </div>
      </div>
    </div>
    <div class="overlay" v-if="popup">
      <Orcamento :atual="atual" @close="popup = false"></Orcamento>
    </div>
  </div>
</template>

<script>
import {default as colors} from "@/assets/colors.json";
import {Printd} from 'printd'
import Orcamento from "@/components/Orcamento";

export default {
  name: "Passo02",
  props: ['ladrilho', 'coresUtilizadas'],
  components: {Orcamento},
  data() {
    return {
      cores: colors,
      cor: '',
      contentSVG: '',
      contentSVG2: '',
      act: '',
      colunas: 2,
      linhas: 2,
      ladrilhoAct: '',
      popup: false,
      atual: {
        modelo: '',
        ladrilho: '',
        tamanho: '',
      }
    }
  },
  mounted() {
    this.getContent();
    if (this.ladrilho.horizontal && !this.ladrilho.floral) {
      this.linhas = 1;
    }
    this.cor = this.cores[0];
    this.atual.modelo = this.ladrilho.modelo;
    this.atual.ladrilho = this.ladrilho.label;
    this.atual.tamanho = this.ladrilho.tamanho;
  },
  methods: {
    getContent() {
      this.contentSVG = localStorage.getItem(this.ladrilho.svg);
      if (this.ladrilho.floral)
        this.contentSVG2 = localStorage.getItem(this.ladrilho.svgFloral);
    },
    ChangePasso(value) {
      this.$emit('changePasso', value);
    },
    getArrayColumns() {
      let matrix = []
      this.colunas.forEach((x) => {
        x.push({})
      })
    },
    changeColor(corAct) {
      let ind = this.cores.findIndex((x) => x.hex == corAct.hex);
      this.act = ind;
      this.cor = corAct;
    },
    printEv() {
      const cssText = `
      body {
        -webkit-print-color-adjust: exact !important;
       }
       body, body * {
           -webkit-print-color-adjust: exact !important;
        }
        .flex-grid {
          display: grid;
          grid-column-gap: 0px;
          grid-row-gap: 0px;
          grid-template-columns: repeat(2, 1fr);
        }

        .col {
          max-width:500px
        }


        .mt-24 {
          margin-top: 24px;
        }

        .p-relative {
          position:relative
        }

        .abs {
          display: flex;
          position: absolute;
          bottom: 0px;
          z-index: 100;
          width: 100%;
          justify-content: center;
          align-items: center;
          height: 100%;
          box-sizing: border-box;
        }

        .imprimir {
          margin-top: 24px;
        }
         .contentS svg {
           width: 100%;
           height: auto;
           display: block;
         }
         .contentS > div >svg > * {
           stroke-opacity: 0.2 !important;
           fill:white;
         }

         .svgR180 svg {
           transform: rotate(-180deg);
         }

         .svgRL180 svg {
           transform: rotate(-180deg);
         }

         .svgRL90 svg {
           transform: rotate(-90deg);
         }

         .svgRM90 svg {
           transform: rotate(90deg);
         }

         button {
          display:none
         }

        .cores ul {
          padding:0px;
          display:flex;
          gap:8px;
          justify-content:flex-start;
        }
        .cores {
        }

        .cores label {
            font-size: 8px;
        }

        .cores li {
          list-style: none;
          width: 54px;
          text-align: center;
          cursor: pointer;
          line-height: normal;
        }

        .cores li span {
          margin-bottom: 8px;
          width: 54px;
          display: block;
          width: 54px;
          height: 54px;
          border-radius: 10px;
          box-sizing: border-box;
        }

        .absText {
          position: absolute;
          bottom: 8px;
          right: 1px;
          z-index: 10;
          opacity: 0.8;
          cursor: vertical-text;
        }

        .absText p {
          font-size: 10px; line-height: 18px; padding: 0 12px; background: #5b6c49; color: white;
        }


       body {
       font-family:Arial, sans-serif;
       }
        `

      const d = new Printd()
      d.print(this.$refs.col, [cssText])
    }
  },
  watch: {
    linhas() {
      let minL = this.ladrilho.horizontal && !this.ladrilho.floral ? 1 : 2;
      this.linhas = this.linhas < minL ? minL : this.linhas;
      this.linhas = this.linhas > 10 ? 10 : this.linhas;
    },


    ladrilho() {
      this.atual.modelo = this.ladrilho.modelo;
      this.atual.ladrilho = this.ladrilho.label;
    },

    colunas() {
      let minL = this.ladrilho.horizontal && !this.ladrilho.floral ? 1 : 2;
      this.colunas = this.colunas < minL ? minL : this.colunas;
      this.colunas = this.colunas > 10 ? 10 : this.colunas;
    }
  }
}
</script>

<style scoped>
.flex-grid {
  display: grid;
  grid-column-gap: 0px;
  grid-row-gap: 0px;
  grid-template-columns: repeat(2, 1fr);
}

.hexagonal {

}

.overlay {
  position: fixed;
  width: 100vw !important;
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #0000006b;
  top: 0;
  left: 0;
  z-index: 100;
}


.rlTop svg {
  position: relative;
  top: 50%;
  left: -25%;
}


.mt-24 {
  margin-top: 24px;
}


.cor-rejunte {
  display: block;
}

.sim {
  padding: 30px;
  background-color: #fff;
  margin-top: 60px;
}

label {
  font-size: 18px;
  display: block;
  font-weight: 700;
  margin-bottom: 15px;
}

.gap18 {
  gap: 18px;
}

.cores label {
  font-size: 9px;
  font-weight: 400;
}

.p-relative {
  position: relative;
}

.gap8 {
  gap: 8px;
}


.flex-end {
  justify-content: flex-end;
}

p {
  line-height: normal;
}

.cores {
  max-height: 500px;
  overflow: auto;
  padding-right: 5px;
}

.cores {
  scrollbar-width: auto;
  scrollbar-color: #bfbfbf #ffffff
}

.cores::-webkit-scrollbar {
  width: 12px
}

.cores::-webkit-scrollbar-track {
  background: #ffffff
}

.cores::-webkit-scrollbar-thumb {
  background-color: #bfbfbf;
  border-radius: 10px;
  border: 3px solid #ffffff
}

.cores li {
  list-style: none;
  width: 84px;
  text-align: center;
  cursor: pointer;
  font-family: Raleway,sans-serif;
  font-size: 14px;
  line-height: normal;
  color: #818181;
  font-weight: 400;
}

.cores li span {
  margin-bottom: 8px;
  width: 54px;
  display: block;
  width: 54px;
  height: 54px;
  border-radius: 10px;
  box-sizing: border-box;
}

.cores li.act span {
  border: 4px solid black;
}

button:not(.vs__clear) {
  padding: 10px 26px;
  cursor: pointer;
  background-color: #6495ed;
  color: #fff;
  margin-top: 20px;
  font-size: 18px;
  appearance: none;
  border: none;
  border-radius: 4px;
}

.col {
  position: relative;
}

.abs {
  display: flex;
  position: absolute;
  bottom: 0px;
  z-index: 100;
  width: 100%;
  justify-content: center;
  align-items: center;
  height: 100%;
  box-sizing: border-box;
}

input {
  height: 40px;
  appearance: none;
  border-radius: 4px;
  padding: 8px;
  font-size: 16px;
  box-sizing: border-box;
  width: 100%;
  border: none;
  border: 1px solid gray;
}

.imprimir {
  margin-top: 24px;
}

.imprimir p {
  font-weight: bold;
  font-size: 16px;
}

.imprimir button {
  margin-top: 0px;
}

.align-center label {
  margin-bottom: 0;
  margin-right: 10px;
  font-weight: 400;
}

.gap18 {
  gap: 18px;
}

.linha {
  position: relative;
  left: 9%;
}

.content {
}

.solicitarOrcamento {
  margin-top: 40px;
  padding-top: 40px;
  border-top: 1px solid black;
}

.sim {
  margin-top: 0px;
}

.absText {
  position: absolute;
  bottom: 1px;
  right: 1px;
  z-index: 10;
  opacity: 0.8;
  cursor: vertical-text;
}

.absText p {
  font-size: 10px; line-height: 18px; padding: 0 12px; background: #5b6c49; color: white;
}


.cores {
  max-height: 500px;
  overflow: auto;
  padding-right: 5px;
}

.cores {
  scrollbar-width: auto;
  scrollbar-color: #bfbfbf #ffffff
}

.cores::-webkit-scrollbar {
  width: 12px
}

.cores::-webkit-scrollbar-track {
  background: #ffffff
}

.cores::-webkit-scrollbar-thumb {
  background-color: #bfbfbf;
  border-radius: 10px;
  border: 3px solid #ffffff
}

.cores li {
  list-style: none;
  width: 54px;
  text-align: center;
  cursor: pointer;
  line-height: normal;
  font-family: Raleway,sans-serif;
  font-size: 14px;
  color: #818181;
  font-weight: 400;
}

.cores li span {
  margin-bottom: 8px;
  width: 54px;
  display: block;
  width: 54px;
  height: 54px;
  border-radius: 10px;
  box-sizing: border-box;
}

.cores li.act span {
  border: 4px solid black;
}
</style>

<style>
body {
  -webkit-print-color-adjust: exact !important;
}

.contentS svg {
  width: 100%;
  height: auto;
  display: block;
}

.contentS > div > svg > * {
  stroke-opacity: 0.2 !important;
}

.svgR180 svg {
  transform: rotate(-180deg);
}

.svgRL180 svg {
  transform: rotate(-180deg);
}

.svgRL90 svg {
  transform: rotate(-90deg);
}


.svgRM90 svg {
  transform: rotate(90deg);
}

.rlTop svg {
  position: relative;
  left: calc(25% - 2px);
  top: calc(-50% + 1px);
}

.rlLeft svg {
  position: relative;
}

.rlLeft + .rlTop svg {
}

.rlTop + .rlLeft svg {
}

.rel1 svg {
  position: relative;
  left: calc(50% - 4px);
}


</style>